import PropTypes from 'prop-types';

export default PropTypes.shape({
  groups: PropTypes.arrayOf(PropTypes.string),
  id: PropTypes.number,
  organization: PropTypes.string,
  timestamp: PropTypes.string,
});
